<script>
	export let name;
	export let SERVER;

	import Footer from './Footer.svelte';
	import Contact from './Home/Contact.svelte';
	import Hero from './Home/Hero.svelte';
	import Jobs from './Home/Jobs.svelte';
	import Learn from './Home/Learn.svelte';
	import Shop from './Home/Shop.svelte';
	import Team from './Home/Team.svelte';
</script>

<main>
	<div id="decorator-top"></div>
	<div id="header" class="container-fluid">
		<header class="d-flex flex-wrap justify-content-center py-0">
		  <a href="/" class="d-flex align-items-center mb-3 mb-md-0 me-md-auto text-dark text-decoration-none">
			<svg class="bi me-2" width="40" height="32"><use xlink:href="#bootstrap"/></svg>
			<span class="fs-4">LOGO</span>
		  </a>
	
		  <ul class="nav">
			<li class="nav-item"><a href="#" class="nav-link py-3 active" aria-current="page">Home</a></li>
			<li class="nav-item"><a href="#" class="nav-link py-3">Shop</a></li>
			<li class="nav-item"><a href="#" class="nav-link py-3">Jobs</a></li>
			<li class="nav-item"><a href="#" class="nav-link py-3">Learn Mandarin</a></li>
			<li class="nav-item"><a href="#" class="nav-link py-3">Our Team</a></li>
		  </ul>
		</header>
	</div>

	<Hero/>

	<Shop SERVER={SERVER} />

	<Learn SERVER={SERVER} />

	<Jobs SERVER={SERVER} />

	<Team SERVER={SERVER} />

	<Contact/>
</main>

<Footer/>

<style>
	main {
		/* text-align: center; */
		/* padding: 1em; */
		/* max-width: 240px; */
		/* margin: 0 auto; */
	}

	#decorator-top {
		height: 1.8rem;
		background-color: #4056A1;
	}

	#header {
		background-color: #C6CAE5;
	}

	#header .nav {
		display: flex;
		align-items: stretch;
	}

	#header .nav .nav-item a {
		color: #333;
		font-size: .6rem;
		text-decoration: none;
		display: inline-block;
		height: 100%;
	}

	#header .nav .nav-item a.active {
		background-color: #F13C1F;
		color: #FFF;
	}

	#header .nav .nav-item a:hover {
		background-color: #673939;
		color: #FFF;
	}

	.bi {
		vertical-align: -.125em;
		fill: currentColor;
	}

</style>